import './css/Content.css';
import Home from './Home.js';
import AboutUs from './AboutUs.js';
import Portfolio from './Portfolio.js';
import OtherServices from './OtherServices.js';
import Location from './Location.js';
import Contact from './Contact.js';
import PasswordRequest from './PasswordRequest.js';

import Architectural from './Architectural.js';
import WeddingsAndEngagements from './WeddingsAndEngagements.js';
import WeddingsAndEngagements1 from './WeddingsAndEngagements1.js';
import WeddingsAndEngagements2 from './WeddingsAndEngagements2.js';
import WeddingsAndEngagements3 from './WeddingsAndEngagements3.js';
import WeddingsAndEngagements4 from './WeddingsAndEngagements4.js';
import WeddingsAndEngagements5 from './WeddingsAndEngagements5.js';
import WeddingsAndEngagements6 from './WeddingsAndEngagements6.js';
import ChurchesSchoolsAndSports from './ChurchesSchoolsAndSports.js';
import CommercialPhotography from './CommercialPhotography.js';
import PartiesAndEvents from './PartiesAndEvents.js';
import FamilyAndKids from './FamilyAndKids.js';
import VIPsPoliticiansAndBigshots from './VIPsPoliticiansAndBigshots.js';
import Portraits from './Portraits.js';

import { Switch, Route } from 'react-router-dom';

function Content() {
  return (
  <div className="content">
    <div className="inner-content">
      <Switch>
        <Route path="/about">
          <AboutUs/>
        </Route>
        <Route path="/portfolio">
          <Portfolio/>
        </Route>
        <Route path="/gallery">
          <></>
        </Route>
        <Route path="/other-services">
          <OtherServices/>
        </Route>
        <Route path="/location">
          <Location/>
        </Route>
        <Route path="/contact">
          <Contact/>
        </Route>
        <Route path="/passwordrequest">
          <PasswordRequest/>
        </Route>
        <Route path="/architectural">
          <Architectural/>
        </Route>
        <Route path="/weddings-and-engagements">
          <WeddingsAndEngagements/>
        </Route>
        <Route path="/weddings-and-engagements-1">
          <WeddingsAndEngagements1/>
        </Route>
        <Route path="/weddings-and-engagements-2">
          <WeddingsAndEngagements2/>
        </Route>
        <Route path="/weddings-and-engagements-3">
          <WeddingsAndEngagements3/>
        </Route>
        <Route path="/weddings-and-engagements-4">
          <WeddingsAndEngagements4/>
        </Route>
        <Route path="/weddings-and-engagements-5">
          <WeddingsAndEngagements5/>
        </Route>
        <Route path="/weddings-and-engagements-6">
          <WeddingsAndEngagements6/>
        </Route>
        <Route path="/churches-schools-and-sports">
          <ChurchesSchoolsAndSports/>
        </Route>
        <Route path="/commercial-photography">
          <CommercialPhotography/>
        </Route>
        <Route path="/parties-and-events">
          <PartiesAndEvents/>
        </Route>
        <Route path="/family-and-kids">
          <FamilyAndKids/>
        </Route>
        <Route path="/vips-politicians-and-bigshots">
          <VIPsPoliticiansAndBigshots/>
        </Route>
        <Route path="/portraits">
          <Portraits/>
        </Route>
        <Route path="/location">
          <Location/>
        </Route>
        <Route path="/">
          <Home/>
        </Route>
      </Switch>
    </div>
  </div>
  );
}

export default Content;
